// 9fbef606107a605d69c0edbcd8029e5d
export default {
  LOAD_FOOTER_DATA: 'LOAD_FOOTER_DATA',
  LOGIN_MODAL_MOUNTED_STATE: 'LOGIN_MODAL_MOUNTED_STATE',
  ACCORDION_EXPAND: 'ACCORDION_EXPAND',
};
